export class ActivityInfo {
  // type 1-促单活动 2-转盘活动
  constructor (type = 1) {
    this.activityId = ''
    this.activityStatus = 1 // 活动状态 0-未开始 1-进行中 2-已结束(可展示) 3-已结束(完全结束)
    this.guidePic = '' // 引导图
    this.apply = false // 是否报名
    this.applyIcon = '' // 报名按钮icon
    this.drawIcon = '' // 领取按钮icon
    this.icon = '' // 宣发背景图
    this.issueType = 2 // 下发类型 1-直接下发 2-邮件下发
    this.rule = ''
    this.roleBind = false
    this.gameId = ''
    this.gameName = ''
    this.banner = ''
    this.gameVoList = []
    this.name = '' // 活动名称
    this.startTime = ''
    this.endTime = ''
    if (type === 2) {
      this.positionVoList = [] // 转盘版位信息
      this.progressVos = [] // 转盘进度信息
      this.taskVos = [] // 转盘任务信息
      this.residueNum = 0 // 转盘剩余次数
      this.totalNum = 0 // 转盘总次数
    }
  }
}

export const FEEDTYPE_MAP = {
  SUCCESS: 'SUCCESS', // 成功
  INSUFFICIENT_GIFT: 'INSUFFICIENT_GIFT', // 礼包码不足
  CONFIRM: 'CONFIRM', // 领取确认
  SHOW_GIFT: 'SHOW_GIFT', // 礼包展示
  MORE_GAME: 'MORE_GAME', // 更多游戏
  REACH_LIMIT: 'REACH_LIMIT', // 已达上限
  RULE: 'RULE', // 规则
  NO_CHANCE: 'NO_CHANCE', // 没有机会
  CONDITION_NOT_SATISFY: 'CONDITION_NOT_SATISFY', // 条件不满足
  SUCCESS_DELAY: 'SUCCESS_DELAY', // 成功延迟发放
}